import { z } from 'zod';
import { constructionStageSchema } from './stages';

export const milestoneSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  slug: z.string(),
  title: z.string(),
  description: z.string(),
  occurredOn: z.string().date(),
  stage: constructionStageSchema.nullable(),
  coverMediaId: z.string().uuid().nullable(),
  coverUrl: z.string().url().nullable(),
  entryIds: z.array(z.string().uuid()).default([]),
  createdAt: z.string().datetime(),
});
export type Milestone = z.infer<typeof milestoneSchema>;

export const milestoneCreateSchema = milestoneSchema.omit({
  id: true,
  userId: true,
  coverUrl: true,
  createdAt: true,
});
export type MilestoneCreate = z.infer<typeof milestoneCreateSchema>;
